import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

const containerBaseStyles = ({ theme }) => css`
  background: ${theme.colors.white};
  border: ${theme.borderWidth.mega} solid ${theme.colors.n500};
  width: 100%;
  min-height: 100px;
  min-width: 200px;
  padding: ${theme.spacings.byte} 0;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled('div')(containerBaseStyles);

const rinkGoalBaseStyles = ({ theme }) => css`
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.circle};
  border: ${theme.borderWidth.mega} solid ${theme.colors.n500};
  width: 40px;
  height: 40px;
  position: absolute;
  top: 50%;
  left: -20px;
  transform: translateY(-50%);
`;

const rinkGoalAlignStyles = ({ alignRight }) =>
  alignRight &&
  css`
    left: auto;
    right: -20px;
  `;

const RinkGoal = styled('div')(rinkGoalBaseStyles, rinkGoalAlignStyles);

const rinkCenterBaseStyles = ({ theme }) => css`
  width: 100%;
  padding: 0 ${theme.spacings.exa};
`;

const RinkCenter = styled('div')(rinkCenterBaseStyles);

const Rink = ({ children }) => (
  <Container>
    <RinkGoal />
    <RinkCenter>{children}</RinkCenter>
    <RinkGoal alignRight />
  </Container>
);

Rink.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default Rink;
